﻿export class DebateBasicData {
    id: number;
    debateStatus: string;
    debateCategory: string;
    debateKind: string;
    startDate: Date;
    endDate: Date;
    active: boolean;
    debateTitle: string;   
    description: string;
}